{
  "dss": {
    "button": {
      "back": "Πίσω",
      "cancel": "Ακύρωση",
      "close": "Κλείσιμο",
      "confirmDelete": "Ναι, διαγραφή",
      "continue": "Συνέχεια",
      "logout": "Αποσύνδεση",
      "passwordReset": "Επαναφορά κωδικού πρόσβασης",
      "save": "Αποθήκευση",
      "verify": "Επαλήθευση"
    },
    "error": {
      "403": "Δεν έχετε πρόσβαση σε αυτήν τη σελίδα.",
      "404": "Αυτή η σελίδα δεν υπάρχει.",
      "generic": "Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά αργότερα.",
      "invalidConfirmationLink": "Ο σύνδεσμος επιβεβαίωσης έχει λήξει ή είναι μη έγκυρος.",
      "throttling": "Πάρα πολλές προσπάθειες. Αυτή η λειτουργία έχει αποκλειστεί για κάποιο χρονικό διάστημα.",
      "title": "Σφάλμα",
      "title403": "Δεν επιτρέπεται η πρόσβαση",
      "title404": "Δεν βρέθηκε"
    },
    "footer": {
      "imprint": "Αποτύπωμα",
      "legalEntity": "ANDREAS STIHL ΜΟΝΟΠΡΟΣΩΠΗ A.E",
      "privacy": "Πολιτική Απορρήτου",
      "terms": "Όροι και Προϋποθέσεις"
    },
    "label": {
      "CRMAccountNumber": "Αριθμός Λογαριασμού CRM",
      "contact": "Επικοινωνία",
      "email": "Email",
      "faq": "Συχνές ερωτήσεις",
      "female": "Κα.",
      "firstname": "Όνομα",
      "help": "Βοήθεια",
      "language": "Γλώσσα",
      "lastname": "Επώνυμο",
      "male": "Κος.",
      "needHelp": "Χρειάζεστε βοήθεια;",
      "newPassword": "Νέος κωδικός πρόσβασης",
      "newPassword2": "Επιβεβαίωση νέου κωδικού πρόσβασης",
      "oldPassword": "Τρέχων κωδικός πρόσβασης",
      "organization": "Οργανισμός",
      "password": "Κωδικός πρόσβασης",
      "required": "required",
      "salutation": "Χαιρετισμός",
      "select": "Παρακαλώ επιλέξτε"
    },
    "lang": {
      "el": "ελληνικά"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Επιβεβαίωση εγγραφής",
        "wait": "Περιμένετε για να ολοκληρωθεί η επιβεβαίωση λογαριασμού."
      },
      "otp": {
        "btnResend": "Επαναποστολή email κωδικού επαλήθευσης",
        "msg": {
          "invalidOTP": "Ο κωδικός πρόσβασης μίας χρήσης που εισαγάγατε δεν είναι έγκυρος.",
          "resendFail": "Η επαναποστολή του κωδικού απέτυχε. Παρακαλούμε προσπαθήστε ξανά αργότερα."
        },
        "spamDetail": "Ελέγξτε τα εισερχόμενά σας και τον φάκελο ανεπιθύμητης αλληλογραφίας για email από την Υποστήριξη STIHL (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Δεν λάβατε email;",
        "subtitle": "Για να συνεχίσετε, πρέπει να επαληθεύσετε τη διεύθυνση email σας.",
        "title": "Επαλήθευση λογαριασμού χρήστη",
        "txtVerifyMail": "Εισαγάγετε τον νέο κωδικό επαλήθευσης που στείλαμε στη διεύθυνση email σας {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Δεν υπάρχει τίποτα προς ενημέρωση.",
          "updateError": "Αποτυχία ενημέρωσης προσωπικών δεδομένων.",
          "updated": "Τα προσωπικά δεδομένα ενημερώθηκαν.",
          "userLoadErr": "Σφάλμα κατά τη φόρτωση των δεδομένων χρήστη. Δοκιμάστε ξανά αργότερα."
        },
        "secOrganization": "Οργανισμός",
        "secPersonal": "Προσωπικά",
        "secSettings": "Προτιμώμενες ρυθμίσεις",
        "title": "Προσωπικές πληροφορίες"
      },
      "postPwSet": {
        "info": "Μπορείτε πλέον να χρησιμοποιήσετε τον νέο σας κωδικό πρόσβασης.",
        "link_name": "Συνέχεια στην αυτοεξυπηρέτηση",
        "title": "Ο κωδικός πρόσβασής σας έχει αλλάξει"
      },
      "resetPW": {
        "title": "Επαναφορά του κωδικού πρόσβασής σας"
      },
      "security": {
        "2fa": {
          "availableMethods": "Διαθέσιμες μέθοδοι 2FA:",
          "info": "Ο έλεγχος ταυτότητας δύο παραγόντων (2FA) είναι μια λειτουργία ασφαλείας που προσθέτει ένα επιπλέον επίπεδο προστασίας στον λογαριασμό σας. Απαιτεί να χρησιμοποιήσετε δύο μεθόδους για να συνδεθείτε, αντί για μόνο ένα όνομα χρήστη και έναν κωδικό πρόσβασης.",
          "method": {
            "email": "Email",
            "emailDesc": "Λάβετε κωδικούς μίας χρήσης μέσω email για την ολοκλήρωση αιτημάτων ελέγχου ταυτότητας.",
            "oath": {
              "add": {
                "button": "Εγγραφή εφαρμογής Authenticator"
              }
            }
          }
        },
        "authenticator": "Εφαρμογή Authenticator",
        "infoFederatedAccount": "Αυτός ο λογαριασμός διαχειρίζεται από τον πάροχο ταυτότητας του οργανισμού σας, επομένως ο κωδικός πρόσβασης δεν μπορεί να αλλάξει εδώ. Για να αλλάξετε τον κωδικό πρόσβασής σας, συνδεθείτε μέσω της σελίδας σύνδεσης του οργανισμού σας ή επικοινωνήστε με τον διαχειριστή IT.",
        "lastUse": "Τελευταία χρήση στις {0}.",
        "msg": {
          "invalidPassword": "Παρεχόμενος μη έγκυρος τρέχων κωδικός πρόσβασης.",
          "passwordAlreadyUsed": "Δεν είναι δυνατή η επαναχρησιμοποίηση των τελευταίων 5 κωδικών πρόσβασης.",
          "pwUpdateError": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια αλλαγής κωδικού πρόσβασης.",
          "pwUpdated": "Ο κωδικός πρόσβασης άλλαξε."
        },
        "noDevice": "Δεν έχει ρυθμιστεί",
        "oathAdd": {
          "appInfo": "Για να διευκολύνετε τη διαδικασία σύνδεσης STIHL, μπορείτε να χρησιμοποιήσετε εφαρμογές Authenticator όπως {0}, {1}, {2}, κ.λπ. για να δημιουργήσετε έναν κωδικό πρόσβασης μίας χρήσης που χρησιμοποιείται ως δεύτερος παράγοντας κατά τη διαδικασία σύνδεσης.<br/>Εάν χάσατε ή ξεχάσατε την κινητή σας συσκευή, μπορείτε να χρησιμοποιήσετε τον κωδικό 2FA που σας αποστέλλεται μέσω email οποιαδήποτε στιγμή.<br/><br/>Ακολουθήστε τις παρακάτω οδηγίες για να ρυθμίσετε τη συσκευή ελέγχου ταυτότητας.",
          "badCode": "Μη έγκυρος κωδικός, δοκιμάστε ξανά.",
          "error": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια καταχώρισης της συσκευής ελέγχου ταυτότητας.",
          "headScan": "1. Σαρώστε τον κωδικό QR με την εφαρμογή ελέγχου ταυτότητας",
          "headVerify": "2. Επαληθεύστε τον κωδικό",
          "infoKey": "κλειδί εγκατάστασης",
          "infoKeyTitle": "Το μυστικό σας δύο παραγόντων",
          "infoScanBottom": "Δεν είναι δυνατή η σάρωση; Μπορείτε να χρησιμοποιήσετε το {0} για να ρυθμίστε χειροκίνητα την εφαρμογή ελέγχου ταυτότητας.",
          "infoVerify": "Εισαγάγετε τον κωδικό που δημιουργήθηκε από την εφαρμογή ελέγχου ταυτότητας.",
          "success": "Η συσκευή ελέγχου ταυτότητας έχει καταχωρηθεί. Μπορείτε τώρα να τη χρησιμοποιήσετε για να συνδεθείτε.",
          "title": "Εγγραφείτε τη συσκευή ελέγχου ταυτότητας δύο παραγόντων"
        },
        "oathDelete": {
          "error": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια διαγραφής της συσκευής ελέγχου ταυτότητας.",
          "success": "Η συσκευή ελέγχου ταυτότητας διαγράφηκε."
        },
        "passkeys": {
          "about": {
            "info1": "Τα κλειδιά πρόσβασης είναι ζεύγη κρυπτογραφικών κλειδιών (ένα δημόσιο κλειδί και ένα ιδιωτικό κλειδί) που αποθηκεύονται από έναν ελεγκτή ταυτότητας που ελέγχετε. Ο ελεγκτής ταυτότητας μπορεί να αποδείξει ότι ένας χρήστης είναι παρών και είναι εξουσιοδοτημένος να χρησιμοποιήσει το κλειδί πρόσβασης. Οι ελεγκτές ταυτότητας αποδεικνύουν την εξουσιοδότηση με PIN, κωδικό πρόσβασης, βιομετρικό ή κωδικό πρόσβασης συσκευής, ανάλογα με τις δυνατότητες και τη διαμόρφωση του ελεγκτή ταυτότητας. Οι ελεγκτές ταυτότητας διατίθενται σε πολλές μορφές, όπως μια συσκευή iPhone ή Android, Windows Hello, ένα κλειδί ασφαλείας υλικού FIDO2 ή ένας διαχειριστής κωδικών πρόσβασης.",
            "info2": "Όταν συνδέεστε στην STIHL χρησιμοποιώντας ένα κλειδί πρόσβασης, ο επαληθευτής σας χρησιμοποιεί κρυπτογραφία δημόσιου κλειδιού για να αποδείξει την ταυτότητά σας στην STIHL χωρίς ποτέ να στείλει το κλειδί πρόσβασης. Τα κλειδιά πρόσβασης συνδέονται με έναν τομέα ιστότοπου, όπως το stihl-sso.com, και απαιτούν ασφαλή σύνδεση, πράγμα που σημαίνει ότι το πρόγραμμα περιήγησης ιστού θα αρνηθεί να επαληθεύσει έναν παρόμοιο ιστότοπο ηλεκτρονικού \"ψαρέματος\" (phishing). Αυτές οι ιδιότητες καθιστούν τα κλειδιά πρόσβασης ιδιαίτερα ανθεκτικά στο ηλεκτρονικό \"ψάρεμα\" (phishing) και πολύ πιο δύσκολο να επιτεθούν σε σχέση με το SMS ή το TOTP 2FA, τα οποία μπορούν να υποστούν ηλεκτρονικό \"ψάρεμα\".",
            "info3": "Οι υπηρεσίες κωδικών πρόσβασης που υποστηρίζονται από το cloud επιτρέπουν τον συγχρονισμό των κωδικών πρόσβασης σε διάφορες συσκευές (όπως συσκευές Apple, συσκευές Android ή διαχειριστές κωδικών πρόσβασης), ώστε να μπορούν να χρησιμοποιηθούν από περισσότερα μέρη και να χάνονται λιγότερο εύκολα. Μόλις ρυθμίσετε ένα συγχρονισμένο κλειδί πρόσβασης σε μία συσκευή, αυτό το κλειδί πρόσβασης είναι διαθέσιμο για χρήση σε πολλές συσκευές που χρησιμοποιούν την ίδια υπηρεσία. Για παράδειγμα, εάν καταχωρίσετε ένα κλειδί πρόσβασης στον λογαριασμό σας iCloud χρησιμοποιώντας το Touch ID του MacBook σας, μπορείτε στη συνέχεια να χρησιμοποιήσετε αυτό το κλειδί πρόσβασης με το πρόσωπο, το δακτυλικό αποτύπωμα, το PIN ή τον κωδικό πρόσβασης της συσκευής σας εναλλακτικά σε πολλές συσκευές που είναι συνδεδεμένες στον ίδιο λογαριασμό iCloud.",
            "title": "Σχετικά με τους κωδικούς πρόσβασης"
          },
          "add": {
            "button": "Προσθήκη νέου κωδικού πρόσβασης",
            "error": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια προσθήκης του νέου κωδικού πρόσβασης.",
            "success": "Προστέθηκε νέο κλειδί πρόσβασης."
          },
          "delete": {
            "button": "Διαγραφή κωδικού πρόσβασης",
            "error": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια διαγραφής αυτού του κωδικού πρόσβασης.",
            "success": "Το κλειδί πρόσβασης διαγράφηκε."
          },
          "edit": {
            "error": "Παρουσιάστηκε σφάλμα κατά την προσπάθεια αποθήκευσης του ονόματος του κωδικού πρόσβασης.",
            "name": "Όνομα κωδικού πρόσβασης",
            "success": "Το όνομα του κωδικού πρόσβασης ενημερώθηκε.",
            "title": "Δώστε στο κωδικό πρόσβασής σας ένα όνομα για να το διακρίνετε από άλλα κλειδιά πρόσβασης"
          },
          "info": "Το κλειδί πρόσβασης είναι μια απλή και ασφαλής εναλλακτική λύση στους κωδικούς πρόσβασης, που επικυρώνει την ταυτότητά σας χρησιμοποιώντας αφή, αναγνώριση προσώπου, κωδικό πρόσβασης συσκευής ή PIN.",
          "none": "Δεν έχει ρυθμιστεί κωδικός πρόσβασης.",
          "reallyDelete": "Είστε βέβαιοι ότι θέλετε να διαγράψετε το κλειδί πρόσβασης;",
          "registeredPasskeys": "Τα καταχωρημένα κλειδιά πρόσβασης:",
          "title": "Κλειδιά πρόσβασης"
        },
        "reallyDeleteDevice": "Είστε βέβαιοι ότι θέλετε να διαγράψετε τη συσκευή ελέγχου ταυτότητας;",
        "secMFA": "Έλεγχος ταυτότητας δύο παραγόντων",
        "secPwdChange": "Αλλαγή κωδικού πρόσβασης",
        "title": "Ασφάλεια"
      },
      "setPW": {
        "acceptTC": "Επιβεβαιώστε τους {όρους} μας και διαβάστε τους {πολιτικούς απορρήτου} μας.",
        "killSSO": "Ακύρωση όλων των ενεργών συνεδριών",
        "msg": {
          "tokenExpired": "Ο σύνδεσμος ή ο κωδικός κωδικού πρόσβασης έληξε. Ακολουθήστε τον σύνδεσμο για να επαναφέρετε τον κωδικό πρόσβασής σας: {link}."
        },
        "privacy": "Πολιτική απορρήτου δεδομένων",
        "terms": "Όροι και Προϋποθέσεις",
        "title": "Εισαγάγετε νέο κωδικό πρόσβασης"
      }
    },
    "validations": {
      "hasDigit": "Πρέπει να περιέχει ψηφίο(α)",
      "hasLowercase": "Πρέπει να περιέχει πεζούς χαρακτήρες",
      "hasSpecial": "Πρέπει να περιέχει ειδικούς χαρακτήρες: {chars}",
      "hasUppercase": "Πρέπει να περιέχει κεφαλαίους χαρακτήρες",
      "invalidCharacters": "Περιέχει μη έγκυρους χαρακτήρες",
      "maxLength": "Μέγιστος αριθμός {max} επιτρεπόμενων χαρακτήρων",
      "minLength": "Απαιτούνται ελάχιστοι {min} χαρακτήρες",
      "notSameAsEmail": "Πολύ παρόμοιο με τη διεύθυνση email",
      "onlyValidCharactersAllowed": "Επιτρέπονται μόνο γράμματα, αριθμοί και κενά.",
      "required": "Απαιτούμενη τιμή",
      "sameAsPassword": "Οι κωδικοί πρόσβασης δεν ταιριάζουν",
      "tcAccepted": "Επιβεβαιώστε τους όρους και τις προϋποθέσεις μας.",
      "validEmail": "Μη έγκυρη διεύθυνση email.",
      "validOTP": "Εισαγάγετε τον κωδικό επαλήθευσης."
    }
  }
}
